import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function creatorNarrativeValidator(isSummaryNotesRequire: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const strippedValue = value.replace(/<[^>]*?>/g, '').trim();
    return strippedValue?.length <= 2 && isSummaryNotesRequire ? { minlength: { requiredLength: 3 } } : null;
  };
}
